import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"pencil\"><path stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke-width=\"1.6\" stroke=\"currentColor\" d=\"M2.333 14h12\" data-follow-stroke=\"currentColor\" /><path stroke-linejoin=\"round\" stroke-width=\"1.6\" stroke=\"currentColor\" d=\"M3.667 8.907v2.426h2.439L13 4.436 10.565 2 3.667 8.907Z\" data-follow-stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol